import React from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { getLoginUserData } from "../utils/getToken";
import { componentKey } from "../screens/login-screen/LoginSlice";
import Loader from "../component-lib/Molecules/loader/Loader";

const PrivateRoute = () => {
  const loginUserData: any = getLoginUserData();
  const parsedToken = JSON.parse(loginUserData);
  const { isTokenRefreshing } = useSelector((state: any) => state[componentKey]);

  // Show loader while token is being refreshed
  if (isTokenRefreshing) {
    return <Loader />;
  }

  return parsedToken?.email ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
